import { defineStore } from 'pinia'
import type { NewInsuranceInfoRes } from 'api/api-type'
import { PAGE_TYPE_MAP } from '@/common/biz/constants'

export const usePageInfo = defineStore('pageInfo', {
  state: () => ({
    pageInfo: {} as NewInsuranceInfoRes
  }),
  getters: {
    isDriverDay: (state) => {
      return state.pageInfo?.ext?.page_type === PAGE_TYPE_MAP.driverDay
    }
  },
  actions: {
    setDetail(info: NewInsuranceInfoRes) {
      this.pageInfo = info
    }
  }
})
